import { FC } from 'react'
import { Text } from '../../'

type FormLabelErrorProps = {
  className?: string
}

const FormLabelError:FC<FormLabelErrorProps> = ({ className = 'd-block mt-5', children }) => {
  return (
    <Text component="label" size="12" color="danger"  className={className}>{children}</Text>
  )
}

export { FormLabelError }